import Vue from 'vue';
import { saveWrap } from './helpers';
import * as roleApi from '@authoringPlatform/../api/roles';
import * as versionApi from '@authoringPlatform/../api/versions';

const getDefaultState = () => ({
  versionKey: 0,
  versionName: '',
  description: '',
  authorName: '',
  onboardTemplateKey: 1,
  featuredProject: {},
  customPageKeysArray: [],
  versionTemplateKey: 1,
  isActive: 0,
  isPublic: false,
  isSellable: false,
  hasPhases: false,
  phases: [],
  versionConfig: {},
  timer: null,
  theme: {},
  demoEmail: '',
  demoUrl: '',
  creationLog: {},
  role: {
    roleKey: 0,
    role: '',
    scenario: '',
    pdfFile: null,
    jobPosition: null,
    companyName: null,
    enableBizCard: false,
  },
  allUsersData: [],
  totalUsers: 0,
  isGatewaySeries: 0,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    getAllUsersData: async ({ commit }, { versionKey, currPage, perPage, sortBy, sortDesc }) => {
      const { totalCount, fetchedScores } = await versionApi.getAllStudentData({
        versionKey,
        page: currPage,
        count: perPage,
        sortBy,
        direction: sortDesc ? 'desc' : 'asc',
      });

      commit('UPDATE_ALL_STUDENT_DATA', {
        allUsersData: fetchedScores,
        totalUsers: totalCount,
      });
    },

    saveRole: saveWrap(async ({ commit }, { roleKey, payload }) => {
      const results = await roleApi.updateRole({ roleKey, payload });
      commit('UPDATE_ROLE', { newRole: payload });
      return results;
    }),

    updateVersion: saveWrap(async ({ commit, state }, { payload, versionKey }) => {
      await versionApi.updateVersion({ versionKey: state.versionKey, payload });
      const versionConfig =
        'versionConfigJson' in payload ? payload.versionConfigJson : state.versionConfig;
      if (payload.isFeaturedProject !== undefined || payload.featuredProjectToggleObj) {
        payload.versionKey = versionKey;
        commit('UPDATE_IS_FEATURED_PROJECT', { payload });
      }
      commit('UPDATE_VERSION', {
        updatedVersion: {
          ...payload,
          versionConfig,
        },
      });
    }),
  },

  mutations: {
    UPDATE_ALL_STUDENT_DATA: (state, { allUsersData, totalUsers }) => {
      Vue.set(state, 'allUsersData', allUsersData);
      Vue.set(state, 'totalUsers', totalUsers);
    },

    INITIALIZE_VERSION: (state, versionData) => {
      Object.entries(versionData).forEach(([versionAttr, val]) => {
        if (versionAttr in state) {
          Vue.set(state, versionAttr, val);
        }
      });
    },
    UPDATE_IS_FEATURED_PROJECT: (state, { payload }) => {
      if (payload.isFeaturedProject) {
        const proj = {
          FK_versionKey: payload.versionKey,
          hasPlayLink: 0,
          hasDownloadProject: 0,
          hasYoutubeUrl: 0,
          youtubeLink: null,
        };
        Vue.set(state, 'featuredProject', proj);
      } else if (payload.featuredProjectToggleObj) {
        const proj = {
          FK_versionKey: payload.versionKey,
          hasPlayLink: +payload.featuredProjectToggleObj.hasPlayLink,
          hasDownloadProject: +payload.featuredProjectToggleObj.hasDownloadProject,
          hasYoutubeUrl: +payload.featuredProjectToggleObj.hasYoutubeUrl,
          youtubeLink: payload.featuredProjectToggleObj.youtubeLink,
        };

        Vue.set(state, 'featuredProject', proj);
      } else {
        Vue.set(state, 'featuredProject', {});
      }
    },
    UPDATE_VERSION: (state, { updatedVersion }) => {
      Object.entries(updatedVersion).forEach(([versionAttr, val]) => {
        if (versionAttr in state) {
          // handle page keys state update
          if (versionAttr === 'customPageKeysArray') {
            const copyOfStateObj = [...state.customPageKeysArray];
            for (let keysObj of val) {
              // handle duplicate version
              if (keysObj.toggle === undefined) {
                copyOfStateObj.push(keysObj);
              } else {
                if (keysObj.toggle) {
                  const keyObj = {
                    FK_onboardPageKey: keysObj.FK_onboardPageKey,
                    sequence: keysObj.sequence,
                  };
                  copyOfStateObj.push(keyObj);
                } else {
                  const idxToRemove = copyOfStateObj.findIndex(
                    (obj) => obj.FK_onboardPageKey === keysObj.FK_onboardPageKey
                  );

                  copyOfStateObj.splice(idxToRemove, 1);
                }
              }
            }
            Vue.set(state, versionAttr, copyOfStateObj);
          } else {
            Vue.set(state, versionAttr, val);
          }
        }
      });
    },

    UPDATE_ROLE: (state, { newRole }) => {
      state.role = newRole;
    },
  },
  getters: {
    getOnboardTemplateKey: (state) => state.onboardTemplateKey,
    getAllUsersInfo: (state) => state.allUsersData,
    getTotalUsersCount: (state) => state.totalUsers,
    getFeatureProjectInfor: (state) => state.featuredProject,
  },
};
